import { Component } from '@angular/core';

@Component({
  selector: 'fgb-representative-page',
  templateUrl: './representative-page.component.html',
  styleUrls: ['./representative-page.component.scss'],
})
export class RepresentativePageComponent {}
